import * as React from 'react';

import { ErrorLayout } from './ErrorLayout';
import image from '../assets/letter.png';

interface IReviewAlreadyExistsErrorProps {
  onClose(): void;
}

export const ReviewAlreadyExistsError: React.FC<IReviewAlreadyExistsErrorProps> = ({ onClose }) => {
  return (
    <ErrorLayout
      image={image}
      title="Вы&nbsp;уже оставили отзыв"
      description={
        <>
          Ваш&nbsp;отзыв опубликован и&nbsp;доступен
          <br />
          на&nbsp;странице жилья
        </>
      }
      actions={[{ label: 'Перейти к отзывам', onClick: onClose }]}
    />
  );
};
